import entities from "../model/entities";

const useStaleTime = (entity, defaultValue = 60 * 1000) => {

    let staleTime = defaultValue;
    if (entities[entity]?.cache === false) staleTime = 0;
    if (entities[entity]?.staleTime !== undefined) staleTime = entities[entity].staleTime;

    return staleTime;

};

export default useStaleTime;